module.exports = "dist/images/components-image-shape-control-square.54ea536.png";